import { atom } from 'recoil';
import { IBillingDetails } from './types';

export const BillingDetailsState = atom<IBillingDetails | null>({
	key: 'billing-details-state',
	default: null,
});

